export const ACCEPT_POLICY = 'ACCEPT_POLICY';
export const SEEN_DISCLAIMER = 'SEEN_DISCLAIMER';

export const policyUpdated = data => ({type: ACCEPT_POLICY, data});
export const disclaimerShow = data => ({type: SEEN_DISCLAIMER, data});